import React from "react";
import AppRoutes from "./Routes";

class App extends React.Component {
  render() {
    return (
      <div>
        <AppRoutes />
      </div>
    );
  }
}

export default App;
